import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

export const findAll = (mid) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors`, { headers: authHeader() })
}

export const findContractors = (mid, params) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors`, { params: params, headers: authHeader() });
}

export const create = (mid, user) => {
  return http.post(API_URL + `/merchants/${mid}/v1/visitors`, user, { headers: authHeader() });
}

export const update = (mid, id, user) => {
  return http.put(API_URL + `/merchants/${mid}/v1/visitors/${id}`, user, { headers: authHeader() });
}

export const findById = (mid, id) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors/${id}`, { headers: authHeader() });
}

export const deleteContractor = (mid, id) => {
  return http.delete(API_URL + `/merchants/${mid}/v1/visitors/${id}`, { headers: authHeader() });
}

export const sendEmail = (mid, id, data) => {
  return http.post(API_URL + `/merchants/${mid}/v1/visitors/${id}/email`, data, { headers: authHeader() });
}

export const sendEmails = (mid, data) => {
  return http.post(API_URL + `/merchants/${mid}/v1/visitors/email`, data, { headers: authHeader() });
}

export const report = (mid) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors/report`, { headers: authHeader() })
}

export const associate = (mid, contractorId, customerId) => {
  return http.put(API_URL + `/merchants/${mid}/v1/visitors/${contractorId}/customers/${customerId}/associate`, null, { headers: authHeader() });
}

export const deAssociate = (mid, contractorId, customerId) => {
  return http.put(API_URL + `/merchants/${mid}/v1/visitors/${contractorId}/customers/${customerId}/de-associate`, null, { headers: authHeader() });
}

export const findCustomers = (mid, contractorId, page, size) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors/${contractorId}/customers?page=${page}&size=${size}`, { headers: authHeader() })
}

export const findByVendorId = (mid, params) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors`, { params, headers: authHeader()})
}

export const findByCustomerId = (customerId, params) => {
  return http.get(API_URL + `/v1/customers/${customerId}/visitors`, { params, headers: authHeader()})
}

export const handleResponse = (response) => {
  return response
}



// WEBPACK FOOTER //
// ./src/service/contractor.service.js